import React from 'react';
import { useTranslation } from 'react-i18next';
import { FileText, File, Grid } from 'react-feather';
import { exportToExcel, exportToPDF, exportToCSV } from '../ExportReport';

/**
 * Export action group (Excel / PDF / CSV) for the report hero.
 *
 * Props:
 *   heading   — report title used in the file
 *   metadata  — array of [label, value] (or strings) shown above the table
 *   columns   — ExportReport column config
 *   data      — full (unpaginated) report rows
 *   fileName  — base name without extension (e.g. "DaywiseReport")
 *   landscape — PDF orientation (default false)
 *   onAfterExport — (format) => void  (e.g. audit log)
 */
const ReportExportButtons = ({ heading, metadata = [], columns = [], data = [], fileName = 'Report', landscape = false, onAfterExport }) => {
    const { t } = useTranslation();
    const disabled = !data || data.length === 0;

    const run = (format) => {
        if (disabled) return;
        if (format === 'excel') exportToExcel(heading, metadata, columns, data, `${fileName}.xlsx`);
        else if (format === 'pdf') exportToPDF(heading, metadata, columns, data, `${fileName}.pdf`, landscape);
        else if (format === 'csv') exportToCSV(heading, metadata, columns, data, `${fileName}.csv`);
        onAfterExport?.(format);
    };

    return (
        <>
            <button type="button" className="v3-btn v3-btn-ghost" onClick={() => run('excel')} disabled={disabled} title={t('Export to Excel')}>
                <Grid size={14} /> {t('Excel')}
            </button>
            <button type="button" className="v3-btn v3-btn-ghost" onClick={() => run('pdf')} disabled={disabled} title={t('Export to PDF')}>
                <File size={14} /> {t('PDF')}
            </button>
            <button type="button" className="v3-btn v3-btn-ghost" onClick={() => run('csv')} disabled={disabled} title={t('Export to CSV')}>
                <FileText size={14} /> {t('CSV')}
            </button>
        </>
    );
};

export default ReportExportButtons;
